import React from "react";

import client from "clients/configs";
import { QueryClientProvider } from "@tanstack/react-query";

import { RecoilRoot } from "recoil";

import Navigator from "./Navigator";

export default function App() {
  return (
    <RecoilRoot>
      <QueryClientProvider client={client}>
        <Navigator />
      </QueryClientProvider>
    </RecoilRoot>
  );
}
